<div class="list_item" [ngClass]="{'seen':notification.seen==1}" (click)="goToDetails()">
    <div class="list__item--link">
        <!--<img src="/assets/bell.png"-->
        <!--alt=""-->
        <!--class="user-image"/>-->

        <div _ngcontent-tcs-c38="" class="details-icon">
            <i _ngcontent-tcs-c38="" class="fa fa-bell" style="
    background-color: #b9b305;"></i></div>
        <div class="title"> {{notification.subject}} </div>
        <div class="message"> {{notification.text}} </div>


        <div style="width: 90% ;text-align: right"> {{notificationDate | date:'medium'}}</div>

    </div>

</div>


<!--{-->
<!--"id": 1,-->
<!--"user_id": 1,-->
<!--"notification_id": 8,-->
<!--"subject": "Ticket Queue Changed",-->
<!--"text": "Ticket queue has changed to: ",-->
<!--"language": "en",-->
<!--"seen": 0,-->
<!--"viewed_at": null,-->
<!--"created_at": "2019-12-12 11:11:24",-->
<!--"updated_at": "2019-12-12 11:11:24"-->
<!--}-->
